module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
 var ls = require('ListService.js').default;
 
    ; __append("\r\n\r\n<div class=\"row\">\r\n    <div class=\"col-md-4 prop-sublabel-7\"><span>App Field</span></div>\r\n    <div class=\"col-md-7 nopadding-l nopadding-r\" style=\"padding-right: 5px!important;\">\r\n        <select name=\"form_field\" id=\"form_field_select\" style=\"width:93%;\">\r\n            <option value=\"\">None</option>          \r\n        </select>\r\n    </div>\r\n    <!--<div class=\"col-md-1 nopadding-r nopadding-l refresh-actions-new\">-->\r\n        <!--<img class=\"refreshFields\" name=\"refreshFields\" title=\"refresh\" src=\"")
    ; __append( require('editor/buttons/gray_refresh.png') )
    ; __append("\" />-->\r\n    <!--</div>-->\r\n\r\n    <div class=\"col-md-1 nopadding-r nopadding-l refresh-actions-new\" style=\"margin-left:-10px!important;\">\r\n        <button type=\"button\" name=\"refreshFields\" title=\"refresh\"  class=\"btn btn-default hvr-glow tbl-icon refresh refreshFields\" style=\"\r\n          margin-top: 0px !important;\">\r\n            <i class=\"pf-refresh-report\" style=\"padding-left: 1px;padding-bottom: 1px;margin-top: 1px;\"></i>\r\n        </button>\r\n    </div>\r\n\r\n</div>")
  }
  return __output;

}